import {Component} from '@angular/core';

@Component({
    selector: 'tfl-favourite-account-icon',
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g>
                <path d="M4023 4058 c-6 -7 -41 -74 -78 -148 -49 -99 -72 -137 -88 -141 -12
-3 -82 -14 -156 -24 -143 -20 -171 -33 -171 -77 0 -16 37 -60 116 -139 l116
-117 -28 -161 c-27 -156 -27 -161 -9 -181 10 -11 29 -20 43 -20 14 0 87 32
162 71 l138 71 134 -71 c74 -39 146 -71 160 -71 14 0 33 9 44 21 18 20 18 24
-9 182 l-28 162 115 110 c101 96 116 115 116 142 0 48 -25 58 -195 82 -82 12
-151 25 -153 29 -2 4 -35 70 -75 147 -71 138 -73 140 -108 143 -21 2 -40 -2
-46 -10z"/>
                <path d="M2 890 l3 -330 28 -27 27 -28 2133 -3 c1507 -2 2143 0 2169 8 67 19
68 27 68 390 l0 320 -288 0 -288 0 -12 -44 c-8 -32 -22 -53 -48 -73 l-37 -28
-192 -3 c-126 -3 -206 0 -235 8 -53 14 -95 57 -104 105 l-7 35 -119 0 c-118 0
-120 0 -120 -22 0 -31 -33 -83 -67 -105 -24 -16 -52 -18 -258 -18 l-232 0 -37
28 c-26 20 -40 41 -48 73 l-12 44 -108 0 -108 0 0 -30 c0 -39 -51 -97 -98
-110 -48 -13 -386 -13 -434 0 -47 13 -98 71 -98 110 l0 30 -130 0 c-128 0
-130 0 -130 -22 0 -31 -33 -83 -67 -105 -23 -15 -54 -19 -207 -21 -99 -2 -200
-1 -223 3 -60 9 -111 55 -119 106 l-7 39 -299 0 -299 0 3 -330z"/>
            </g>
        </svg>
    `
})
export class FavouriteAccountIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/favourite.account.icon.ts